export const ACTIVITY = 'ACTIVITY';
export const INTERACTIVE = 'INTERACTIVE';
export const COMPONENT = 'COMPONENT';
export const SCENARIO = 'SCENARIO';
export const PATHWAY = 'PATHWAY';
